enum UserRoleEnum {
  USER = 1
}

const userRoleNames: Map<number, string> = new Map<number, string>([
  [UserRoleEnum.USER, 'User']
])

export { UserRoleEnum, userRoleNames }